<template>
    <div>
        <div class="row">
            <div class="col-12">
                <g-table-sync
                    ref="invoicesTable"
                    :app="app"
                    :view="view"
                    :columns="columns"
                    :default-limit="20"
                    :required-filters="tableFilters"
                    pagination="loadmore"
                    @edit="openForm"
                >
                    <template slot="head-right" slot-scope="data" v-if="isBoss">
                        <!-- Combinar albaranes en facturas unica -->
                        <a-tooltip v-if="data.select.length > 1" placement="top">
                            <template v-if="isEligibleForCombine(data.select).ok" slot="title">
                                {{ `Combinar ${data.select.length} albaranes a factura` }}
                            </template>

                            <template v-else slot="title">
                                {{ isEligibleForCombine(data.select).message }}
                            </template>

                            <a-button
                                :disabled="!isEligibleForCombine(data.select).ok"
                                class="mr-2"
                                :loading="converting"
                                @click="combineMultipleInvoicesToBills(data.select)"
                            >
                                <fa-icon v-show="!xport.loading" :icon="['fas', 'file-plus']" />
                            </a-button>
                        </a-tooltip>
                        <!-- Transformar a factura (multiple) -->
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{
                                    data.select.length === 0
                                        ? 'No se han seleccionado albaranes'
                                        : `Transformar ${data.select.length} albaran/es a factura`
                                }}
                            </template>
                            <a-button
                                v-show="data.select.length"
                                :loading="converting"
                                @click="transformMultipleInvoicesToBills(data.select)"
                            >
                                <fa-icon v-show="!xport.loading" :icon="['fas', 'file-export']" />
                            </a-button>
                        </a-tooltip>
                    </template>

                    <!-- Empresa -->
                    <template slot="client_name" slot-scope="{ item }">
                        <truncate
                            tag="span"
                            class="clickable"
                            @click="$router.push(`/client/${item.client._EntityId}`)"
                        >
                            {{ item.client_name }}
                        </truncate>
                    </template>

                    <!-- total -->
                    <template slot="total" slot-scope="{ item }">
                        <span v-if="item.client.show_prices === 1 || isBoss"> {{ item.total | price }}€ </span>
                        <span v-else></span>
                    </template>

                    <!-- Fecha -->
                    <template slot="date" slot-scope="{ item }">
                        <span>{{ item.date }}</span>
                    </template>

                    <template slot="download" slot-scope="{ item }" v-if="isValidEnv">
                        <a-tooltip placement="top">
                            <template slot="title">
                                <span>Generar ticket e imprimir</span>
                            </template>
                            <a-button
                                :loading="printing === item._EntityId"
                                :disabled="printing !== false && printing !== item._EntityId"
                                @click="generateTicketAndPrint(item)"
                            >
                                <fa-icon :icon="['fas', 'print']" class="mr-2" /> Imprimir
                            </a-button>
                        </a-tooltip>
                    </template>

                    <!-- PDF -->
                    <template slot="downloadPDF" slot-scope="{ item }">
                        <a-button
                            :loading="printing === item._EntityId"
                            :disabled="printing !== false && printing !== item._EntityId"
                            @click="printInvoicePDFType(item)"
                        >
                            <fa-icon :icon="['far', 'file-pdf']" class="mr-2" />
                            Imprimir
                        </a-button>
                    </template>

                    <!-- PDF FACTURA -->
                    <template slot="download_no_reload" slot-scope="{ item }" v-if="isBoss">
                        <a-tooltip v-if="item.invoice" placement="top">
                            <template slot="title">
                                <span>Descargar Factura</span>
                            </template>
                            <a-button :disabled="converting" @click="openBill(item)">
                                <fa-icon :icon="['fas', 'eye']" class="mr-1" /> Ver
                            </a-button>
                        </a-tooltip>
                        <a-tooltip v-else placement="top">
                            <template slot="title">
                                <span>Factura a un no generada</span>
                            </template>
                            <a-button :disabled="true"> <fa-icon :icon="['fas', 'eye']" class="mr-1" /> Ver </a-button>
                        </a-tooltip>
                    </template>

                    <!-- Transformar a factura (item) -->
                    <template slot="actions" slot-scope="{ item }">
                        <g-item-actions app="invoices" :item="item" @edit="openForm">
                            <template slot="left">
                                <a-tooltip placement="top" v-if="isBoss">
                                    <template slot="title"> Transformar a factura </template>
                                    <a-button
                                        class="mr-2"
                                        :loading="converting"
                                        @click="transformInvoicesToBills([item])"
                                    >
                                        <fa-icon :icon="['fas', 'file-export']" />
                                    </a-button>
                                </a-tooltip>
                            </template>
                        </g-item-actions>
                    </template>

                    <template slot="_mobile" slot-scope="{ item, index, deleteItems }">
                        <ticket
                            :item="item"
                            :index="index"
                            :loading="printing === item._EntityId"
                            @print-pdf="printInvoicePDFType"
                            @print-ticket="generateTicketAndPrint"
                            @open-invoice="openBill(item)"
                            @edit="openForm"
                            @delete="deleteItems([item])"
                        />
                    </template>
                </g-table-sync>
            </div>
        </div>

        <!-- Modal para los observaciones de transformacion multiple -->
        <a-modal v-model="multipleObservations.visible" title="Añadir observaciones">
            <div class="row">
                <div class="col-12">
                    <a-textarea
                        v-model="multipleObservations.text"
                        placeholder="Observaciones"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                        :disabled="converting"
                    />
                </div>
            </div>

            <template #footer>
                <a-button
                    key="back"
                    type="danger"
                    :disabled="converting"
                    @click="() => (multipleObservations.visible = false)"
                >
                    Cancelar
                </a-button>
                <a-button key="submit" type="primary" :loading="converting" @click="createMultipleBills">
                    Crear facturas
                </a-button>
            </template>
        </a-modal>

        <!-- Modal para los observaciones de combinacion multiple -->
        <a-modal v-model="combineForm.visible" title="Fecha de factura" ok-text="Combinar">
            <div class="row">
                <div class="col-12">
                    <g-field
                        v-model="combineForm.date"
                        type="date"
                        name="date"
                        placeholder="Fecha"
                        :disabled="converting"
                    />
                </div>
            </div>

            <template #footer>
                <a-button key="back" type="danger" :disabled="converting" @click="() => (combineForm.visible = false)">
                    Cancelar
                </a-button>
                <a-button key="submit" type="primary" :loading="converting" @click="combineInvoices">Combinar</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import printJS from 'print-js'
import transform from './mixins/transform'
import printer from '@/application/mixins/printer'
import moment from 'moment'

export default {
    name: 'Invoices',
    mixins: [transform, printer],
    data() {
        return {
            app: 'invoices',
            view: 'invoiceList',
            printing: false,
            xport: {
                enabled: false,
                loading: false,
                dates: [],
            },
            multipleObservations: {
                visible: false,
                loading: false,
                items: [],
                observations: '',
            },

            ticketsToPrint: 2,
        }
    },
    computed: {
        tableFilters() {
            return [...this.routeFilter]
        },
        routeFilter() {
            if (this.$route?.query?.field && this.$route?.query?.value) {
                return [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            [this.$route.query.field]: {
                                type: 3,
                                int: parseInt(this.$route.query.value, 10),
                                opt: '=',
                            },
                        },
                    },
                ]
            }
            return []
        },
        userId() {
            return this.$gestios.profile.ID
        },
        isBoss() {
            return this.$gestios.auth.check({ scopes: ['_BOSS'] })
        },
        isValidEnv() {
            if (window.cordova) {
                return true
            }

            return false
        },
        columns() {
            const columns = []

            columns.push({
                title: 'Nº',
                index: 'serie',
                order: true,
                search: true,
            })

            columns.push({
                title: 'Empresa',
                index: 'client_name',
                order: false,
                search: true,
                slot: 'client_name',
            })

            columns.push({
                title: 'Fecha',
                index: 'date',
                order: true,
                slot: '_date',
                search: false,
                date: true,
            })

            if (this.isValidEnv) {
                columns.push({
                    title: 'Ticket',
                    width: '190px',
                    slot: 'download',
                })
            }

            columns.push({
                title: 'PDF',
                width: '190px',
                slot: 'downloadPDF',
            })

            columns.push({
                title: 'Total',
                index: 'total',
                order: true,
                slot: 'total',
            })

            if (this.isBoss) {
                columns.push({
                    title: 'FACTURA',
                    index: 'invoice',
                    width: '190px',
                    slot: 'download_no_reload',
                })
            }

            columns.push({
                title: 'Acciones',
                slot: 'actions',
            })

            return columns
        },
    },
    created() {
        this.$hub.$on('newInvoice', () => {
            this.$router.push({ name: 'invoicesNew' })
        })
        this.$hub.$on('listInvoiceNotBill', () => {
            this.$router.push({ name: 'invoices_without_bill' })
        })
    },
    beforeDestroy() {
        this.$hub.$off('newInvoice')
        this.$hub.$off('listInvoiceNotBill')
    },
    methods: {
        openForm(item) {
            this.$router.push({
                name: 'invoicesEdit',
                params: { id: item._EntityId },
            })
        },
        openInvoice(invoice, fieldName = 'pdf') {
            if (invoice[fieldName]) {
                if (window.cordova || this.$settings.isMobileView) {
                    window.open(invoice[fieldName].Link, '_system')
                } else {
                    printJS(invoice[fieldName].Link)
                }
            }
        },
        printInvoice(invoice) {
            this.printing = invoice._EntityId

            // Generar el pdf del ticket
            this.$lambda
                .get(`invoice/${invoice._EntityId}/${this.userId}`)
                .then((response) => {
                    const item = response.data
                    this.$gestios.$cache.items('invoices').edit({ id: item._EntityId, params: item })
                    this.$message.success('Albaran generado 😄')
                    this.openInvoice(item)
                    this.printing = false
                })
                .catch((err) => {
                    this.$message.error(err.message)
                    this.printing = false
                })
        },
        printInvoicePDFType(invoice) {
            this.printing = invoice._EntityId

            this.$lambda
                .get(`invoices/${invoice._EntityId}/pdf/${this.userId}`)
                .then((response) => {
                    const item = response.data
                    this.$gestios.$cache.items('invoices').edit({ id: item._EntityId, params: item })
                    this.$message.success('Albaran generado 😄')
                    this.openInvoice(item, 'pdf2')
                    this.printing = false
                })
                .catch((err) => {
                    console.error(err)
                    this.$message.error(err.message)
                    this.printing = false
                })
        },
        async generateTicketAndPrint(item) {
            this.printing = item._EntityId
            const resItem = await this.generateTicket(item)
            if (resItem) await this.printTicket(resItem)
            this.printing = false
        },
        generateTicket(item) {
            return new Promise((resolve, reject) => {
                // Generar el ticket para impresora
                this.$lambda
                    .get(`invoice/${item._EntityId}/ticket/${this.userId}`)
                    .then((response) => {
                        const resItem = response.data
                        this.$gestios.$cache.items('invoices').edit({ id: resItem._EntityId, params: resItem })
                        this.$message.success('Ticket Listo para imprimir')
                        this.printing = false
                        resolve(resItem)
                    })
                    .catch((err) => {
                        this.$message.error(err.message)
                        this.printing = false
                        resolve(null)
                    })
            })
        },
        async printTicket(item) {
            if (!item.ticket_json) {
                this.$gestios.$message.error('No hay datos de ticket para imprimir')
            }

            this.printing = true
            let ticket = null

            try {
                ticket = item.ticket_json.replaceAll('&quot;', '"')
                ticket = JSON.parse(ticket)
            } catch (err) {
                this.printing = false
                this.$gestios.$message.error('Ocurrio un error al leer los datos del ticket')
                console.error('Ocurrio un error al parsear el json', err)
            }

            // imprimimos
            try {
                if (ticket && Array.isArray(ticket)) {
                    this.printing = true

                    // ticket 1
                    this.$gestios.$message.success(`Imprimiendo ticket: 1 de 2`)
                    await this.printOnBTPrinter(ticket)

                    // Espera
                    await new Promise((resolve) => setTimeout(resolve, 6 * 1000))

                    // ticket 2
                    this.$gestios.$message.success(`Imprimiendo ticket: 2 de 2`)
                    await this.printOnBTPrinter(ticket)

                    this.printing = false
                }
            } catch (err) {
                console.error(err)
            } finally {
                this.printing = false
            }
        },
        async exportData() {
            if (this.$gestios.auth.check({ scopes: ['_BOSS'] })) {
                this.xport.loading = true

                const params = {
                    from: this.xport.dates[0].format('YYYY-MM-DD'),
                    to: this.xport.dates[1].format('YYYY-MM-DD'),
                }

                try {
                    const response = await this.$lambda.get(`invoices/excel?from=${params.from}&to=${params.to}`, {
                        responseType: 'blob',
                    })

                    this.$message.success('Exportación finalizada. Descargando fichero...')

                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'download',
                        `Partes de ${this.xport.dates[0].format('LL')} a ${this.xport.dates[1].format('LL')}.xlsx`
                    )
                    document.body.appendChild(link)
                    link.click()
                    link.parentNode.removeChild(link)
                } catch (err) {
                    this.$message.error('Ocurrió un error en la exportacion de los partes')
                }

                this.xport.enabled = false
                this.xport.loading = false
            }
        },
        async openBill(item) {
            const billId = item?.invoice?._EntityId

            if (billId) {
                this.$router.push({ name: 'billsEdit', params: { id: billId } })
            } else {
                this.$gestios.$message.error('No se encontro factura para este albaran')
            }
        },
        transformMultipleInvoicesToBills(items) {
            this.multipleObservations.items = items
            this.multipleObservations.text = ''
            this.multipleObservations.visible = true
        },
        combineMultipleInvoicesToBills(items) {
            this.combineForm.items = items
            this.combineForm.date = moment()
            this.combineForm.visible = true
        },
        async createMultipleBills() {
            this.converting = true

            const items = this.multipleObservations.items.map((item) => ({
                ...item,
                observations: `${item.observations} \n ${this.multipleObservations.text}`,
            }))

            await this.transformInvoicesToBills(items)

            this.converting = false
            this.multipleObservations.visible = false
        },
        async combineMultipleInvoicesToBill(selectedItems) {
            this.converting = true

            try {
                // Recogemos los ids de los albaranes seleccionados
                const invoices = selectedItems.map((inv) => inv._EntityId)

                // Llamamos al Lambda
                this.$lambda
                    .get(`/invoice/combine/${this.userId}/${invoices.join('_')}`)
                    .then((response) => {
                        if (response) {
                            // console.log(response)
                            // Aqui es donde se manda a imprimir el pdf
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message)
                        this.printing = false
                        resolve(null)
                    })
            } catch (e) {
                console.error(e)
                this.$message.error('Algo salio mal combinando los albaranes')
            } finally {
                this.converting = false
            }
        },
    },
}
</script>

<style lang="scss">
.clickable {
    cursor: pointer;
}
</style>
